import { createEvent, restore, sample } from 'effector'
import { ParticipantRequest, ParticipantResponse, Participant } from './types'
import { fx } from '../../../../libs'
import {
  isAllElementsOfSearchTextNotExist,
  mapSearchText,
} from '../../../../libs/utils'
import { $params } from '../../../../features/router'

export const participantListMounted = createEvent<ParticipantRequest>()

export const disqualifyParticipantMounted = createEvent<{
  id: string
  reason: string
}>()

export const awardedCashDepositMounted = createEvent<{
  id: string
  accountId: string
  amount: string
}>()

export const getParticipantList = fx<ParticipantRequest, ParticipantResponse>({
  method: 'GET',
  url: `/contest_participant`,
})

export const disqualifyParticipant = fx<
  {
    status: string
    reason: string
  },
  void
>({
  method: 'PUT',
  url: `/contest_participant`,
})

export const awardedCashDeposit = fx<
  {
    accountId: string
    amount: string
  },
  void
>({
  method: 'PUT',
  url: `/contest_participant`,
})

export const $participantList = restore<Participant[]>(
  getParticipantList.doneData.map((a) => a.body.items),
  [],
)

export const $totalCountOfParticipantList = restore(
  getParticipantList.doneData.map((a) => a.body.total),
  0,
)

sample({
  // @ts-ignore
  clock: participantListMounted,
  source: $params,
  fn: (
    params,
    { limit, page, orderBy, orderDirection, searchText, filters },
  ) => {
    let id
    if (params) {
      id = params.demoContestID
    }

    if (orderDirection === 'descend') {
      orderDirection = '-'
    } else if (orderDirection === 'ascend') {
      orderDirection = ''
    }

    let query = {
      limit,
      page,
    }

    if (orderBy) {
      // @ts-ignore
      query['order'] = orderDirection + orderBy
    }

    if (filters) {
      //TODO данные мапперы необходимо переписать, когда бэк будет паринимать правильный JSON
      let newObj = Object.keys(filters).reduce((accumulator, key) => {
        if (filters[key as keyof typeof filters] != null) {
          accumulator[key as keyof typeof filters] =
            //TODO
            key === 'client.country'
              ? filters[key as keyof typeof filters]
              : `${filters[key as keyof typeof filters]}`
        }

        return accumulator
      }, {} as any)

      if (!isAllElementsOfSearchTextNotExist(searchText)) {
        newObj = { ...newObj, ...mapSearchText(searchText) }
      }

      newObj = { ...newObj, contestId: id }

      if (Object.keys(newObj).length) {
        // @ts-ignore
        query['where'] = `${JSON.stringify(newObj)}`
      }
    }

    return {
      query: {
        ...query,
        populate: JSON.stringify(['Participant.client']),
      },
    }
  },
  target: getParticipantList,
})

sample({
  clock: disqualifyParticipantMounted,
  fn: ({ reason, id }) => {
    return {
      url: `/contest_participant/${id}`,
      body: {
        status: 'disqualified',
        reason,
      },
    }
  },
  target: disqualifyParticipant,
})

sample({
  clock: awardedCashDepositMounted,
  fn: ({ id, accountId, amount }) => {
    return {
      url: `/contest_participant/${id}`,
      body: {
        accountId,
        amount,
      },
    }
  },
  target: awardedCashDeposit,
})
